import { useState, type KeyboardEvent } from 'react'
import { X } from 'lucide-react'

/**
 * Hash-set style input — mirrors the web FilterBar HASH_SET ("Type and Enter").
 * Values are stored as chips; Enter / comma commits the current draft.
 */
export function TagInput({
  values,
  onChange,
  placeholder = 'Type and Enter'
}: {
  values: string[]
  onChange: (next: string[]) => void
  placeholder?: string
}) {
  const [draft, setDraft] = useState('')

  const commit = (raw: string) => {
    const value = raw.trim()
    if (!value) return
    if (values.some((existing) => existing.toLowerCase() === value.toLowerCase())) {
      setDraft('')
      return
    }
    onChange([...values, value])
    setDraft('')
  }

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault()
      commit(draft)
      return
    }
    if (event.key === 'Backspace' && !draft && values.length) {
      onChange(values.slice(0, -1))
    }
  }

  return (
    <div className={`ramp-tags${values.length ? ' has-value' : ''}`}>
      {values.map((value) => (
        <span key={value} className='ramp-tags-chip'>
          <span className='ramp-tags-chip-label'>{value}</span>
          <button
            type='button'
            className='ramp-tags-chip-remove'
            aria-label={`Remove ${value}`}
            onClick={() => onChange(values.filter((entry) => entry !== value))}
          >
            <X size={11} />
          </button>
        </span>
      ))}
      <input
        type='text'
        className='ramp-tags-input'
        value={draft}
        placeholder={values.length ? '' : placeholder}
        onChange={(event) => setDraft(event.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => commit(draft)}
      />
    </div>
  )
}
